import { render, staticRenderFns } from "./GroupInbox.vue?vue&type=template&id=57f81228&"
import script from "./GroupInbox.vue?vue&type=script&lang=js&"
export * from "./GroupInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports